var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuiconsAllHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 63,
    viewBox: "0 0 289 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_208)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_33_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6251 53.0442C35.5971 53.0442 45.3023 43.0464 45.3023 30.7135C45.3023 18.3806 35.5971 8.38281 23.6251 8.38281C11.6531 8.38281 1.94781 18.3806 1.94781 30.7135C1.94781 43.0464 11.6531 53.0442 23.6251 53.0442Z",
    fill: "#3AB64A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_33_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.163 9.60059H76.8079V54.2618H120.163V9.60059Z",
    fill: "#1076BC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_33_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.964 13.6602H151.668V50.2012H198.964V13.6602Z",
    fill: "#ED1D24"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_33_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.623 2.29273L230.469 30.7061L258.051 59.7084L286.205 31.2951L258.623 2.29273Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33_208",
    x: 0.787783,
    y: 7.45479,
    width: 45.6746,
    height: 46.9812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.232007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.580016
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33_208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_33_208",
    x: 75.6478,
    y: 8.67256,
    width: 45.6747,
    height: 46.9812,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.232007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.580016
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33_208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_33_208",
    x: 150.508,
    y: 12.7321,
    width: 49.6161,
    height: 38.8611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.232007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.580016
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33_208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_33_208",
    x: 229.309,
    y: 1.36494,
    width: 58.056,
    height: 59.7351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.232007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.580016
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33_208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 289,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 63)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuiconsAllHorizontal);
export default __webpack_public_path__ + "static/media/menuicons-all-horizontal.c744b4361f2f829e949ae5c1a7a1ace1.svg";
export { ForwardRef as ReactComponent };